import { ActionType } from "typesafe-actions";

import * as actions from "./actions";

export type AirlinesAction = ActionType<typeof actions>;

export interface AirlinesItemByIata extends BaseAirlinesItem {
  pdate: string;
  airlineIata?: string;
}

export interface BaseAirlinesItem {
  sumClicksCount: number;
  sumUniqueClicksCount: number;
  sumSales: number;
  avgClicksShare: number;
  avgStr: number;
  avgProductivity: number;
}

export interface AirlinesItem extends BaseAirlinesItem {
  airlineIata: string;
  items?: AirlinesItemByIata[];
}

export enum AirlinesActionTypes {
  TABLE_FETCH_REQUEST = "@Airlines/TABLE_FETCH_REQUEST",
  TABLE_FETCH_SUCCESS = "@Airlines/TABLE_FETCH_SUCCESS",
  TABLE_FETCH_ERROR = "@Airlines/TABLE_FETCH_ERROR",

  IATA_FETCH_REQUEST = "@Airlines/IATA_FETCH_REQUEST",
  IATA_FETCH_SUCCESS = "@Airlines/IATA_FETCH_SUCCESS",
  IATA_FETCH_ERROR = "@Airlines/IATA_FETCH_ERROR",

  GENERATE_REPORT_REQUEST = "@Airlines/GENERATE_REPORT_REQUEST",
}

export interface AirlinesState {
  readonly count: number;
  readonly isLoading: boolean;
  readonly items: AirlinesItem[];
  readonly itemsByIata: Record<string, AirlinesItemByIata[]>;
}

export interface IataResponse {
  iata: string;
  items: AirlinesItemByIata[];
}
